import { PropsWithChildren, createContext, useContext, useState } from 'react';

import { DrawerContext } from '@/common/components/Drawer/DrawerContext';

interface ContextValue {
  isActive: boolean;
  handleOpenDrawer: () => void;
  handleCloseDrawer: () => void;
}

export const ComingSoonDrawerContext = createContext({} as ContextValue);

export const ComingSoonDrawerContextProvider = ({ children }: PropsWithChildren) => {
  const [isActive, setIsActive] = useState(false);
  const { handleBackdropOpen, handleBackdropClose } = useContext(DrawerContext);

  const handleOpenDrawer = () => {
    setIsActive(true);
    handleBackdropOpen?.();
  };

  const handleCloseDrawer = () => {
    setIsActive(false);
    handleBackdropClose?.();
  };

  return (
    <ComingSoonDrawerContext.Provider value={{ isActive, handleOpenDrawer, handleCloseDrawer }}>
      {children}
    </ComingSoonDrawerContext.Provider>
  );
};
